/* ============================================================
   PSYCHED — Build Your Stack  ·  standalone behaviour
   No dependency on polo.js. Adds the whole stack to the Shopflo
   cart in one /cart/add.js call, then opens the Shopflo cart.
   ============================================================ */
(function(){
  'use strict';

  /* ---------- Shopflo bridge ---------- */
  var FLO_CART='handleFloCartBtn';
  function floFn(n){return typeof window[n]==='function'?window[n]:null;}
  function whenFloReady(n,t){t=t||3000;return new Promise(function(res){var f=floFn(n);if(f)return res(f);var s=Date.now();var p=setInterval(function(){var fn=floFn(n);if(fn){clearInterval(p);res(fn);}else if(Date.now()-s>t){clearInterval(p);res(null);}},100);});}
  function callFlo(n,fb){return whenFloReady(n).then(function(fn){if(!fn){if(typeof fb==='function')fb();return false;}try{fn();return true;}catch(e){if(typeof fb==='function')fb();return false;}});}

  /* ---------- cart primitives ---------- */
  function addToCart(items){
    var body=Array.isArray(items)?{items:items}:{id:Number(items.id),quantity:Number(items.quantity)||1};
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)})
      .then(function(r){if(!r.ok)return r.json().then(function(e){throw new Error(e.description||e.message||'Could not add to cart');});return r.json();});
  }
  function fetchCart(){return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).catch(function(){return null;});}
  function refreshThemeCart(){
    return fetchCart().then(function(cart){
      if(!cart)return null;
      document.querySelectorAll('.cart-count').forEach(function(el){
        if(el.classList.contains('cart-count-drawer'))el.innerHTML='('+cart.item_count+')';
        else el.innerHTML=cart.item_count>100?'~':String(cart.item_count);
      });
      var tot=document.querySelector('header-total-price');
      if(tot&&typeof tot.updateTotal==='function')tot.updateTotal(cart);
      var fs=document.querySelector('free-ship-progress-bar');
      if(fs&&typeof fs.init==='function')fs.init(cart.items_subtotal_price);
      return cart;
    });
  }
  function openCart(){
    return callFlo(FLO_CART,function(){
      document.dispatchEvent(new CustomEvent('shopflo-event:add-to-cart'));
      var c=document.querySelector('cart-notification');
      if(c&&typeof c.open==='function'){try{c.open();return;}catch(e){}}
      window.location.href='/cart';
    });
  }

  /* ---------- toast ---------- */
  function toast(msg){
    var el=document.getElementById('bstack-toast');
    if(!el){el=document.createElement('div');el.id='bstack-toast';el.setAttribute('style','position:fixed;left:50%;bottom:90px;transform:translateX(-50%) translateY(20px);background:#171717;color:#fff;padding:10px 18px;border-radius:999px;font-size:13px;opacity:0;pointer-events:none;transition:opacity .2s,transform .2s;z-index:99999');document.body.appendChild(el);}
    el.textContent=msg;requestAnimationFrame(function(){el.style.opacity='1';el.style.transform='translateX(-50%) translateY(0)';});
    clearTimeout(toast._t);toast._t=setTimeout(function(){el.style.opacity='0';el.style.transform='translateX(-50%) translateY(20px)';},2400);
  }

  function money(cents,fmt){try{var n=Math.round(cents/100).toLocaleString('en-IN');return (fmt||'₹{{amount}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/,n);}catch(e){return '₹'+Math.round(cents/100);}}

  /* ---------- per-card image gallery ---------- */
  function initGalleries(root){
    root.querySelectorAll('[data-bb-gal]').forEach(function(gal){
      var track=gal.querySelector('[data-bb-track]');if(!track)return;
      var slides=[].slice.call(track.querySelectorAll('.polo-bb-slide'));
      var dots=[].slice.call(gal.querySelectorAll('.polo-bb-dots i'));
      if(slides.length<2)return;
      function w(){return track.clientWidth||1;}
      function cur(){return Math.round(track.scrollLeft/w());}
      function sync(){var i=cur();dots.forEach(function(d,x){d.classList.toggle('on',x===i);});}
      function go(i){i=Math.max(0,Math.min(slides.length-1,i));track.scrollTo({left:i*w(),behavior:'smooth'});}
      var p=gal.querySelector('[data-bb-prev]'),n=gal.querySelector('[data-bb-next]');
      if(p)p.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();go(cur()-1);});
      if(n)n.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();go(cur()+1);});
      track.addEventListener('scroll',function(){clearTimeout(track._t);track._t=setTimeout(sync,60);},{passive:true});
    });
  }

  /* ---------- the builder ---------- */
  function initBuildStack(root){
    var fmt=root.getAttribute('data-money-format')||'₹{{amount}}';
    var noun=root.getAttribute('data-noun')||'products';
    var cards=[].slice.call(root.querySelectorAll('[data-stack-card]')).filter(function(c){return c.getAttribute('data-available')!=='false';});
    var tiers=[].slice.call(root.querySelectorAll('[data-stack-tier]'));
    var bar=root.querySelector('[data-stack-bar]');
    var countEl=root.querySelector('[data-stack-count]');
    var targetEl=root.querySelector('[data-stack-target]');
    var totalEl=root.querySelector('[data-stack-total]');
    var progEl=root.querySelector('[data-stack-prog]');
    var checkout=root.querySelector('[data-stack-checkout]');
    var ctaEl=root.querySelector('[data-stack-cta]');
    var beginBtn=root.querySelector('[data-stack-begin]');
    var grid=root.querySelector('[data-stack-grid]');
    var idleCta=ctaEl?ctaEl.textContent:'Choose your stack';
    var target=2, packPrice='';

    function selected(){return cards.filter(function(c){return c.classList.contains('sel');});}
    function variantIdOf(card){var s=card.querySelector('[data-stack-variant]');if(!s||!s.value)return null;var id=parseInt(s.value,10);return isNaN(id)?null:id;}
    function priceOf(card){return parseInt(card.getAttribute('data-price')||'0',10)||0;}

    function render(){
      var sel=selected(), n=sel.length, atCap=n>=target;
      cards.forEach(function(c){var pick=c.querySelector('[data-stack-pick]');if(!pick)return;var lock=atCap&&!c.classList.contains('sel');pick.disabled=lock;c.classList.toggle('locked',lock);});
      if(countEl)countEl.textContent=n;
      if(targetEl)targetEl.textContent=target;
      var sum=0; sel.forEach(function(c){sum+=priceOf(c);});
      if(totalEl){
        if(n>=target&&packPrice)totalEl.innerHTML='<b>'+packPrice+'</b>'+(sum>0?' <s>'+money(sum,fmt)+'</s>':'');
        else if(n>0)totalEl.innerHTML='<b>'+money(sum,fmt)+'</b>';
        else totalEl.innerHTML='';
      }
      if(progEl)progEl.style.width=Math.min(100,(n/target)*100)+'%';
      if(checkout)checkout.disabled=n!==target;
      if(bar){bar.classList.toggle('show',n>0);bar.classList.toggle('ready',n===target);}
      if(ctaEl)ctaEl.textContent=n===0?idleCta:(n<target?('Add '+(target-n)+' more '+noun):('Add stack to cart'+(packPrice?' · '+packPrice:'')));
    }

    function toggleCard(card){
      var pick=card.querySelector('[data-stack-pick]');
      if(card.classList.contains('sel')){card.classList.remove('sel');if(pick)pick.classList.remove('on');}
      else{
        if(selected().length>=target){toast('Your stack is full — remove one to swap');return;}
        if(!variantIdOf(card)){toast('Pick a size first');return;}
        card.classList.add('sel');if(pick)pick.classList.add('on');
      }
      render();
    }
    cards.forEach(function(card){var pick=card.querySelector('[data-stack-pick]');if(pick)pick.addEventListener('click',function(){if(!pick.disabled)toggleCard(card);});});

    function selectTier(t){
      tiers.forEach(function(x){var on=x===t;x.classList.toggle('on',on);x.setAttribute('aria-pressed',on?'true':'false');});
      target=parseInt(t.getAttribute('data-qty')||'2',10);
      packPrice=t.getAttribute('data-price')||'';
      var sel=selected();
      if(sel.length>target){for(var i=target;i<sel.length;i++){sel[i].classList.remove('sel');var p=sel[i].querySelector('[data-stack-pick]');if(p)p.classList.remove('on');}}
      render();
    }
    tiers.forEach(function(t){t.addEventListener('click',function(){selectTier(t);});});
    if(tiers.length){var it=tiers.filter(function(t){return t.classList.contains('on');})[0]||tiers[0];selectTier(it);}
    else if(targetEl)target=parseInt(targetEl.textContent||'2',10);

    if(beginBtn&&grid)beginBtn.addEventListener('click',function(){grid.scrollIntoView({behavior:'smooth',block:'start'});});

    if(checkout)checkout.addEventListener('click',function(e){
      e.preventDefault();
      var sel=selected();
      if(sel.length!==target)return;
      var items=[];
      for(var i=0;i<sel.length;i++){var vid=variantIdOf(sel[i]);if(!vid){toast('Pick an in-stock size for each');return;}items.push({id:vid,quantity:1});}
      checkout.disabled=true;var lbl=ctaEl?ctaEl.textContent:'';if(ctaEl)ctaEl.textContent='Adding…';
      addToCart(items).then(refreshThemeCart).then(function(){return openCart();})
        .catch(function(err){toast(err.message||'Could not add to cart');})
        .then(function(){checkout.disabled=false;if(ctaEl)ctaEl.textContent=lbl;render();});
    });

    render();
  }

  /* ---------- size chart modal (open/close + inches/cm) ---------- */
  function initSizeChart(root){
    var modal=root.querySelector('[data-sizechart]');
    if(!modal)return;
    function open(){modal.classList.add('open');modal.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';}
    function close(){modal.classList.remove('open');modal.setAttribute('aria-hidden','true');document.body.style.overflow='';}
    root.querySelectorAll('[data-sizechart-open]').forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();open();});});
    modal.querySelectorAll('[data-sizechart-close]').forEach(function(b){b.addEventListener('click',close);});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&modal.classList.contains('open'))close();});
    var label=modal.querySelector('[data-unit-label]');
    modal.querySelectorAll('[data-unit-toggle] button').forEach(function(b){b.addEventListener('click',function(){
      modal.querySelectorAll('[data-unit-toggle] button').forEach(function(x){x.classList.remove('on');});
      b.classList.add('on');
      var u=b.getAttribute('data-unit');
      modal.querySelectorAll('[data-in]').forEach(function(s){s.hidden=(u!=='in');});
      modal.querySelectorAll('[data-cm]').forEach(function(s){s.hidden=(u!=='cm');});
      if(label)label.textContent=(u==='cm')?'Centimetres':'Inches';
    });});
  }

  function boot(){
    document.querySelectorAll('[data-build-stack]').forEach(function(root){
      try{initGalleries(root);}catch(e){}
      try{initBuildStack(root);}catch(e){if(window.console)console.warn('[build-stack]',e);}
      try{initSizeChart(root);}catch(e){}
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
